import { render, staticRenderFns } from "./Q4sVendorNote.vue?vue&type=template&id=778564aa&scoped=true"
import script from "./Q4sVendorNote.vue?vue&type=script&lang=ts"
export * from "./Q4sVendorNote.vue?vue&type=script&lang=ts"
import style0 from "./Q4sVendorNote.vue?vue&type=style&index=0&id=778564aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778564aa",
  null
  
)

export default component.exports